import { Spinner } from '@/components/common';
import { CardContainer } from '../containers';
import Icons from '@/const/icons';
import { EmptyStateCaseDetails } from './EmptyStateCaseDetails';
import { FileType, StatusTypes } from '@/interfaces';
import { useDocumentationModals } from '@/hooks/useDocumentationModals';
import * as React from 'react';
import { DocumentationModals } from './documentation/DocumentationModals';
import { DocumentationRow } from './documentation/DocumentationRow';

interface Props {
	caseName?: string;
	applicationId?: number;
	status?: StatusTypes;
	className?: string;
	filesApplications?: FileType[];
	uploadButton?: boolean;
	clientApproveEmail?: boolean;
	classNameContainer?: string;
	emptyMessage?: string;
	clientFirstname?: string;
	clientLastname?: string;
	refetch: () => void;
	stepName?: string;
	isClientView?: boolean;
}

export const Documentation: React.FC<Props> = ({
	caseName,
	applicationId,
	status,
	className,
	filesApplications,
	refetch,
	classNameContainer,
	emptyMessage = "You haven't uploaded any documents yet.",
	uploadButton = true,
	clientFirstname,
	clientLastname,
	clientApproveEmail,
	stepName,
	isClientView = false,
}) => {
	const modals = useDocumentationModals({ applicationId, refetch });
	const isDeclined = status === 'Declined';

	return (
		<>
			<CardContainer
				title="Documentation"
				buttonLabel="Upload"
				buttonIcons={Icons.documentUpload}
				uploadButton={uploadButton}
				icon={Icons.filesEmptyState}
				setFile={modals.handleUploadFile}
				status={status}
				stepName={stepName}
				clientApproveEmail={clientApproveEmail}
				isLoading={!filesApplications}
				className={classNameContainer}
				classNameTitle="!text-xl"
			>
				{filesApplications ? (
					filesApplications?.length > 0 ? (
						<ul className={className}>
							{filesApplications.map((item, index) => (
								<DocumentationRow
									key={'action-required-' + index}
									item={item}
									isDeclined={isDeclined}
									onClickModal={modals.handleOnClickModal}
								/>
							))}
						</ul>
					) : (
						<EmptyStateCaseDetails text={emptyMessage} />
					)
				) : (
					<div className="flex items-center justify-center w-full h-full">
						<Spinner type="loadingPage" />
					</div>
				)}
			</CardContainer>
			<DocumentationModals
				modals={modals}
				caseName={caseName}
				applicationId={applicationId}
				uploadButton={uploadButton}
				clientFirstname={clientFirstname}
				clientLastname={clientLastname}
				isClientView={isClientView}
				refetch={refetch}
			/>
		</>
	);
};
